<template>
  <div class="panel1">
    <h2 class="flex-row gap-xs flex-align-center">
      <div class="dot">1</div>
      <div v-if="join.kit" class="select-enrollment">My Enrollment Option</div>
      <div v-else class="select-enrollment">Select an enrollment option</div>

      <i @click="join.info.kit = 0" class="pi pi-pen-to-square" />
    </h2>
    <div v-if="join.kit" class="kit small m-xs-t">
      <div class="name">{{ join.kit.name }}</div>
      <div v-if="join.kit.unit_price" class="kit-price">
        <Currency :amount="join.kit.unit_price" />
      </div>
    </div>
    <div v-else>
      <p class="m-2xs-t">Select one of the enrollment options below:</p>
      <div class="flex-row gap-xl m-xl-t">
        <div v-for="kit of join.kits" class="flex1 kit">
          <!-- <AutoThumbnail :src="kit.image" /> -->
          <b class="name">{{ kit.name_without_price }}</b>
          <div v-if="kit.unit_price" class="kit-price">
            <Currency :amount="kit.unit_price" />
          </div>
          <div v-html="kit.description" class="description m-sm-y" />
          <Button @click.prevent="assignKit(kit)" class="grey add-to-bag">
            Add to Bag
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useJoinStore } from "@/stores/join";
import type { SignupItem } from "@paparazzi/types/paparazzi.api.viewsets.signup_items";
import Button from "primevue/button";
import { useRouter } from "vue-router";
import Currency from "../shop/Currency.vue";

const router = useRouter();

const join = useJoinStore();

function assignKit(kit: SignupItem) {
  join.info.kit = kit.id ?? 0;
  if (kit.jewelry_count ?? 0 > 0) {
    router.push({ name: "shop" });
  }
}
</script>

<style scoped>
.kit {
  .name {
    color: var(--Paparazzi-Pink, #ec008c);
    font-family: Indivisible;
    font-size: 18px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    text-transform: uppercase;
    margin-bottom: var(--3XS, 4px);
  }
  .kit-price {
    display: block;
    color: var(--Black, #000);
    font-family: Indivisible;
    font-size: 18px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    text-transform: uppercase;
  }
}
.kit.small {
  .name,
  .kit-price {
    font-size: 14px;
  }
}
i.pi {
  font-size: 12px;
}

.description.m-sm-y:deep(ul) {
  padding-left: 24px;
}
.description.m-sm-y:deep(ul ul) {
  list-style-type: disc;
}

@media (max-width: 800px) {
  .panel1:deep(.flex-row.gap-xl.m-xl-t) {
    flex-direction: column !important;
  }
  .select-enrollment {
    text-align: left;
  }
}
</style>
